import { Component, Input } from '@angular/core';
import { Constants, taxElections } from '../../../shared/utilities/Constants';
import { TaxInfo } from '../../models';

@Component({
  standalone: false,
  selector: 'mm-tax-withholding',
  templateUrl: './tax-withholding.component.html',
  styleUrls: ['./tax-withholding.component.scss']  
})

export class TaxWitholdingComponent {
  @Input() taxInfo: TaxInfo | null;
  @Input() isNraAccount: boolean | undefined | null;
  @Input() stateCode: string | null;
  tooltipVerbiage = Constants.nraText;

  get stateCodeLabel() {
    if (this.stateCode && !this.isNraAccount) {
      return ` (${this.stateCode})`;
    } else {
      return '';
    }
  }

  get federalTaxRate() {
    if (this.taxInfo && this.taxInfo.federalTaxRate) {
      return this.taxInfo.fedCustomerTaxElections === taxElections.federal ? 'None' : this.taxInfo.federalTaxRate;
    } else {
      return this.taxInfo?.federalTaxRate;
    }
  }

  get stateTaxRate() {
    if (this.taxInfo && this.taxInfo.stateTaxRate) {
      return this.taxInfo.stateCustomerTaxElections === taxElections.state ? 'None' : this.taxInfo.stateTaxRate;
    } else {
      return this.taxInfo?.stateTaxRate;
    }
  }
}
